var map = {
	"./tech-apache-airflow.svg": 2102,
	"./tech-excel.svg": 2103,
	"./tech-git.svg": 2104,
	"./tech-google-sheets.svg": 2105,
	"./tech-gray-chatgpt.svg": 1328,
	"./tech-gray-excel.svg": 1329,
	"./tech-gray-git.svg": 1330,
	"./tech-gray-google-sheets.svg": 1331,
	"./tech-gray-jupyter.svg": 1332,
	"./tech-gray-multiple.svg": 1333,
	"./tech-gray-other.svg": 1334,
	"./tech-gray-powerbi.svg": 1335,
	"./tech-gray-python.svg": 1336,
	"./tech-gray-r.svg": 1337,
	"./tech-gray-sql.svg": 1338,
	"./tech-gray-tableau.svg": 1339,
	"./tech-gray-theory.svg": 1340,
	"./tech-powerbi.svg": 2106,
	"./tech-python (2).svg": 2107,
	"./tech-python.svg": 2108,
	"./tech-r.svg": 2109,
	"./tech-responsive-apache-airflow.svg": 612,
	"./tech-responsive-artificial-intelligence.svg": 545,
	"./tech-responsive-chatgpt.svg": 613,
	"./tech-responsive-data.svg": 614,
	"./tech-responsive-excel.svg": 615,
	"./tech-responsive-git.svg": 616,
	"./tech-responsive-google-sheets.svg": 617,
	"./tech-responsive-jupyter.svg": 618,
	"./tech-responsive-langchain.svg": 619,
	"./tech-responsive-multiple.svg": 620,
	"./tech-responsive-powerbi.svg": 621,
	"./tech-responsive-powerpoint.svg": 622,
	"./tech-responsive-python.svg": 623,
	"./tech-responsive-r.svg": 624,
	"./tech-responsive-sql.svg": 625,
	"./tech-responsive-tableau.svg": 626,
	"./tech-responsive-theory.svg": 627,
	"./tech-sql.svg": 2110,
	"./tech-tableau.svg": 2111,
	"./tech-theory.svg": 2112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4188;